import {Component,Inject,OnInit} from '@angular/core';
import {BoiteLien} from "@domain/boitelien/boitelien";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import * as _ from "lodash";
import {BoiteLienService} from "@components/admin/parametre/personnalisation/boite-lien/boite-lien.service";
import {finalize} from "rxjs/operators";

/**
 * Composant de création / modification d'une boîte à liens
 *
 * @author Lionel Gimenez
 * @date 15/07/2025
 */
@Component({
    host: {'data-test-id': 'boite-lien-dialog'},
    selector: 'boite-lien-detail',
    templateUrl: './boite-lien-dialog.component.html'
})
export class BoiteLienDialogComponent implements OnInit {
    /** Modèle BoiteLien */
    boiteLien: BoiteLien;

    /** Indicateur de sauvegarde */
    isSaving: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        private boiteLienService: BoiteLienService,
        @Inject(MAT_DIALOG_DATA) private data: { boiteLien: BoiteLien },
        private dialogRef: MatDialogRef<BoiteLienDialogComponent>,
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Si on est en création, on initialise le modèle sinon on le copie
        this.boiteLien = _.cloneDeep(this.data.boiteLien) ?? new BoiteLien();
    }

    /**
     * Enregistrement
     */
    save(): void {
        this.boiteLienService.save(this.boiteLien)
            .pipe(finalize(() => this.isSaving = false))
            .subscribe((success: boolean) => {
                //Si on n'a pas d'erreur
                if (success) {
                    //On ferme
                    this.dialogRef.close();
                }
            });
    }

    /**
     * Suppression
     */
    delete(): void {
        this.boiteLienService.delete(this.boiteLien.idLien)
            .pipe(finalize(() => this.isSaving = false))
            .subscribe((success: boolean) => {
                //Si on n'a pas d'erreur
                if (success) {
                    //On ferme
                    this.dialogRef.close();
                }
            });
    }
}